import ChangePassword from './ChangePasswordPage';

export default ChangePassword;
